import React from 'react';
import cn from 'classnames';
import { Button, Icon } from '@economic/taco';

interface Props {
    title: string;
    bulletPoints: string[];
    className: string;
    buttonTitle: string;
    callbackFunction: () => void;
    hideInstantPaymentOffersChecked?: boolean;
}

export default function SignupOption(props: Props) {
    const { title, bulletPoints, buttonTitle, callbackFunction, hideInstantPaymentOffersChecked } = props;
    const className = cn('flex w-1/2 flex-col items-start', props.className);
    return (
        <div className={className}>
            <div className="flex w-full flex-col">
                <strong>{title}</strong>
                <div className="w-full bg-grey-50 pt-6 pb-2 px-4 my-4">
                    <ul className="mb-0">
                        {bulletPoints.map((el, index) => (
                            <li key={index} className="pb-4">
                                <div className="flex items-center">
                                    <Icon name="tick" className="rounded-full yt-grey-inverted mr-2 border-none" />
                                    {el}
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            <Button appearance="primary" fluid onClick={callbackFunction} disabled={hideInstantPaymentOffersChecked}>
                {buttonTitle}
            </Button>
        </div>
    );
}
